<template>
  <div class="d-flex flex-column w-100 notification-container">
    <div class="d-flex justify-content-between py-2 px-3 header-container">
      <div class="notification-header">Notifications</div>
      <button
          v-if="totalUnreadNotifications > 0"
          @click="handleMarkAll"
          type="button"
          class="wfh-btn-link-primary notification-action"
      >
        Mark All As Read
      </button>
    </div>

    <div v-if="notifications.length > 0" class="d-flex flex-column notification-list" ref="notification-list">
      <button
          v-for="notification of notifications"
          class="notification-body"
          type="button"
          @click="handleItemClick(notification)"
          :key="notification.id"
          :class="{'active': notification.read_at === null}"
      >
        <div>
          <user-avatar
              :avatarURL="notification.data.sender.avatar_src"
          ></user-avatar>
        </div>
        <div>
          <div class="notification-text">
            <strong>{{ notification.data.sender.name }}</strong>
            {{ ` ${notification.data.data.message} ` }} <strong>{{ notification.data.data.title }}</strong>
          </div>
          <div class="notification-timestamp">{{ displayTime(notification.created_at) }}</div>
        </div>
      </button>
    </div>

    <div v-else class="empty-state">
      Interact with your teammates to get notifications!
    </div>

    <div class="notification-footer" v-if="totalNotifications > this.notifications.length">
      <button
          @click="loadMoreNotifications"
          type="button"
          class="wfh-btn-link-primary notification-action"
      >
        View More
      </button>
    </div>
  </div>
</template>

<script>
import { displayTime } from '@/services/TimeDisplayService';

export default {
  data () {
    return {
      page: 1,
    };
  },

  computed: {
    notifications () {
      return this.$store.state.notifications;
    },

    totalNotifications () {
      return this.$store.state.totalNotifications;
    },

    totalUnreadNotifications () {
      return this.$store.state.notifications.reduce((carry, current) => {
        if (!current.read_at) {
          return carry + 1;
        }

        return carry;
      }, 0);
    },
  },

  methods: {
    loadMoreNotifications () {
      this.page++;

      this.$store.dispatch('getUserNotifications', {
        page: this.page,
      });

      setTimeout(this.handleScrollList, 600);
    },

    handleScrollList () {
      this.$refs['notification-list'].scrollTo({
        top: this.$refs['notification-list'].scrollHeight + 80,
        behavior: 'smooth',
      });
    },

    async handleItemClick (notification) {
      await axios.post(route('notifications.mark-as-read'), {
        'notification_ids': [notification.id],
      });

      window.location.href = notification.data.data.link;
    },

    async handleMarkAll () {
      const notificationIds = this.notifications.map(notification => {
        return notification.id;
      });

      await axios.post(route('notifications.mark-as-read'), {
        'notification_ids': notificationIds,
      });

      await this.$store.dispatch('updateUnreadNotifications');
      await this.$store.dispatch('setNotifications', this.notifications.map((notification) => {
        notification.read_at = new Date();

        return notification;
      }));
    },

    displayTime,
  },
};
</script>

<style scoped lang="scss">
.notification-container {
  font-size: 14px;
  letter-spacing: 0;
  line-height: 18px;

  .header-container {
    border-bottom: 1px solid rgba(194, 194, 194, 0.7);
  }

  .notification-header {
    color: #222227;
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 22px;
  }

  .notification-action {
    font-weight: 600;
    font-family: "Open Sans", sans-serif;
    padding: 0 !important;
  }

  .notification-list {
    max-height: 240px;
    overflow-y: auto;
  }

  .notification-body {
    background: transparent;
    border: none;
    outline: none;
    display: grid;
    column-gap: 8px;
    grid-template-columns: 50px auto;
    padding: 10px 15px;

    &.active {
      background-color: #e4f0ff;
    }

    &:not(:last-child) {
      border-bottom: 1px solid #dce2ed;
    }
  }

  .notification-timestamp {
    color: #808fa4;
    font-family: ".SF NS Display", sans-serif;
    font-size: 12px;
    letter-spacing: 0;
    line-height: 22px;
    text-align: left;
  }

  .notification-text {
    color: #303030;
    font-family: ".SF NS Display", sans-serif;
    font-size: 14px;
    letter-spacing: 0;
    line-height: 18px;
    text-align: left;
  }

  .empty-state {
    width: 100%;
    text-align: center;
    padding: 15px 0;
  }

  .notification-footer {
    width: 100%;
    text-align: center;
    padding: 12px 0;
    border-top: 1px solid #dce2ed;
  }
}
</style>
